

import { Component, inject, OnInit } from '@angular/core';
import { NotificationService } from '../../notifications/services/notification.service';
import { HomeService } from 'src/app/source/features/home/services/home.service';
import {  WordPressProfileService } from 'src/app/source/features/profile/profile.service';
import { NavBar, NavBarItem } from './nav-bar.interface';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss'],
})
export class NavBarComponent implements OnInit {
  private notificationService: NotificationService = inject(NotificationService);
  private wordPressProfileService: WordPressProfileService = inject(WordPressProfileService);
  private homeService: HomeService = inject(HomeService);

  public navItems: NavBarItem[] = [];
  public rrss: NavBarItem[] = [];


  public isMenuOpen: boolean = false;

  public legalLinks: { slug: string; title: string }[] = [];

  // Mega dropdown state (desktop)
  public isMegaOpen: boolean = false;
  public activeItem: any | null = null;
  public hoveredSubItem: any | null = null;
;

  ngOnInit(): void {
    this.getNavBarData();
  }


  // getNavBarData() {
  //   this.homeService.getNavbarData().subscribe({
  //     next: (profileMenuItems: NavBar) => {
  //       console.log(profileMenuItems)
  //       this.navItems = profileMenuItems.items.filter(item => item.label !== 'Inicio');
  //       this.profileService.setPerfilMenuItems(profileMenuItems.profile);
  //     },
  //     error: (error) => {
  //       console.error('Error loading NavBar data:', error);
  //     }
  //   });
  // }

getNavBarData() {
  let attempts = 0;
  const maxAttempts = 3;

  const tryLoadNavBar = () => {
    console.log(`Intento ${attempts + 1} de cargar NavBar...`);
    const token = sessionStorage.getItem('ahm_at');

    if (token) {
      this.homeService.getNavbarData().subscribe({
        next: (profileMenuItems: NavBar) => {
          console.log('navBar',profileMenuItems)
          this.navItems = profileMenuItems.items.filter(item => item.label !== 'Inicio');
          this.rrss = profileMenuItems.rrss;
          this.wordPressProfileService.setPerfilMenuItems(profileMenuItems.profile);
        },
        error: (error) => {
          console.error('Error loading NavBar data:', error);
        }
      });
    } else {
      attempts++;
      if (attempts < maxAttempts) {
        setTimeout(tryLoadNavBar, 2000);
      } else {
        console.warn('No se encontró token después de varios intentos. No se cargó NavBar.');
      }
    }
  };

  tryLoadNavBar();
}





  onNotificationClick() {
    this.notificationService.openPanel();
  }

  onProfileClick() {
    this.wordPressProfileService.openPanel();
  }

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  // Desktop mega dropdown behaviors
  onItemEnter(item: any): void {
    if (item?.subitems?.length) {
      this.activeItem = item;
      this.isMegaOpen = true;
      this.hoveredSubItem = null;
      return;
    }
    // If item has no subitems, close the mega dropdown
    this.isMegaOpen = false;
    this.activeItem = null;
    this.hoveredSubItem = null;
  }


  onSearchEnter(): void {
    this.activeItem = { label: 'Buscar', customContent: 'search' };
    this.isMegaOpen = true;
    this.hoveredSubItem = null;
  }

  onNavLeave(): void {
    this.isMegaOpen = false;
    this.activeItem = null;
    this.hoveredSubItem = null;
  }

  onSubEnter(sub: any): void {
    if (sub?.subitems?.length) {
      this.hoveredSubItem = sub;
    } else {
      this.hoveredSubItem = null;
    }
  }

  public mobileDropdowns: { [label: string]: boolean } = {};

  toggleMobileDropdown(label: string) {
    this.mobileDropdowns[label] = !this.mobileDropdowns[label];
  }

  isExternal(url: string): boolean {
    return url?.startsWith('http');
  }


  getCategorySlug(url: string): string | null {
    try {
      const parts = new URL(url).pathname.split('/');
      const categoryIndex = parts.indexOf('category');
      if (categoryIndex >= 0 && parts.length > categoryIndex + 1) {
        return parts[categoryIndex + 1]; // devuelve por ejemplo "calidad-2"
      }
    } catch (error) {
      console.warn('Invalid URL:', url);
    }
    return null;
  }
}
